/**
 * @param {number} number The number to check if it's even or not
 * @returns {boolean} Wherever the number is even or not
 */
export default function isEven(number) {
  number = Number(number)

  return number === 0 || Boolean(number && !(number % 2))
}
